<template lang="pug">
.bloco-historico-monitoramento
    .bloco-historico-monitoramento__historico
        .bloco-historico-monitoramento__header
            .bloco-historico-monitoramento__titulo
                h3 {{ $t('mensagens.comuns.monitoramento.historicoMonitoramento') }}
                el-checkbox(v-model='somenteAlerta', label='false') {{ $t('mensagens.comuns.monitoramento.mostrarResultadosComAlertas') }}
        .bloco-historico-monitoramento__lista
            TimelineHistoricoMonitoramento(:dados='historicos')

    .territorio-monitoramento-mapa
        mapa(
            height='100%',
            idMapa='Mapahistorico',
            :key='keyMapa',
            :mapLayersConfigs='camadasMapa',
            :mapConfig='configuracoesMapa',
            :camadaCentralizadaNome='camadaCentralizadaNome',
            ref='mapaHistorico'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import TimelineHistoricoMonitoramento from '@/components/monitoramento/TimelineHistoricoMonitoramento';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import HistoricoService from '@/services/HistoricoService';
import TipoMonitoramento from '@/constants/TipoMonitoramento';
export default {
    name: 'BlocoHistoricoMonitoramento',
    components: {
        Mapa,
        TimelineHistoricoMonitoramento
    },
    props: {
        monitoramento: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    ferramentasControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: false,
                diagnostico: false
            },
            keyMapa: 100,
            camadaCentralizadaNome: null,
            somenteAlerta: false,
            historicos: []
        };
    },
    mounted() {
        this.configureLayersMapa();
        this.buscarHistorico();
    },

    watch: {
        somenteAlerta() {
            this.buscarHistorico();
        }
    },

    methods: {
        configureLayersMapa() {
            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.monitoramento.territorio.geometria
            };

            this.camadasMapa.push(layerAreaMonitorada);
            this.$nextTick(() => {
                this.$refs.mapaHistorico.mapa.zoomOut(1);
            });
        },
        async buscarHistorico() {
            this.historicos = [];
            try {
                const { data } =
                    await HistoricoService.buscarHistoricoMonitoramentoPorAreaMonitoradaId(
                        this.monitoramento.id,
                        this.somenteAlerta
                    );

                data.forEach(historico => {
                    this.historicos.push({
                        ...historico,
                        tipoMonitoramento: TipoMonitoramento.SOCIOAMBIENTAL,
                        territorio: this.monitoramento.territorio,
                        color: historico.identificouNovaRestricao
                            ? 'var(--warning)'
                            : '#09413C',
                        loading: false
                    });
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.buscarMonitoramento')
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.bloco-historico-monitoramento {
    display: flex;
    margin-top: 25px;
    .bloco-historico-monitoramento__historico {
        width: 50%;
        padding: 0px 10px 0px 0px;
        .bloco-historico-monitoramento__header {
            align-items: center;
            margin: 2px 3px 10px 0px;
            .bloco-historico-monitoramento__titulo {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                label {
                    color: var(--primary-font-color);
                    font-size: 1rem;
                    font-weight: 400;
                    line-height: 1.5;
                }
            }
        }
    }
    .bloco-historico-monitoramento__lista {
        background: var(--white);
        margin: 2px 3px 2px 0px;
        box-shadow: 0px 0px 2px 0px var(--block-shadow);
        border-radius: 5px;
        border: 1px solid var(--default-border-color);
        overflow-y: auto;
        height: 600px;
    }
    .territorio-monitoramento-mapa {
        width: 50%;
        height: 600px;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        margin: 33px 0px 0px 0px;
        margin-bottom: 14px;
    }

    h3 {
        margin-bottom: 0px;
        color: var(--black);
        font-weight: 500;
    }
    .dimensao-mapa {
        height: 100% !important;
    }
}
</style>
